<template>
  <div class="key-subinfos">
    <KeyInfo
      v-for="item in items"
      :key="item.label"
      :icon="item.icon"
      :class="{ 'bold-subinfo': item.bold }"
    >
      <template #label>
        {{ item.label }}
      </template>
      <template #main>
        <p
          v-if="loading"
          class="loading-zone"
        >
          <Loader />
        </p>
        <p
          v-else-if="item.condition"
          class="subinfo"
          :class="{ 'is-bold': item.bold }"
        >
          {{ item.value }}
          <Badge v-if="item.badge">
            {{ item.badge }}
          </Badge>
        </p>
        <p
          v-else
          class="not-available"
        >
          N/A
        </p>
      </template>
    </KeyInfo>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Badge, Loader, KeyInfo } from '@stakeui';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const riskProfile = computed(() => props.client?.risk_profile);
const servicesDesired = computed(() => props.client?.services_desired);
const retirementAge = computed(() => props.client?.retirement_age);
const financialGoals = computed(() => props.client?.financial_goals);

const items = computed(() => ([
  { icon: 'fas fa-tachometer-alt',
    label: 'Client Risk Tolerance',
    condition: riskProfile?.value?.tolerance_level,
    value: riskProfile?.value?.tolerance_level,
    badge: riskProfile?.value?.tolerance_number,
  },
  {
    icon: 'fas fa-asterisk',
    label: 'Portfolio Risk',
    condition: riskProfile?.value?.portfolio_risk_level,
    value: riskProfile?.value?.portfolio_risk_level,
    badge: riskProfile?.value?.portfolio_risk_number,
  },
  {
    icon: 'fas fa-align-center',
    label: 'Risk Alignment',
    condition: riskProfile?.value?.risk_alignment,
    value: riskProfile?.value?.risk_alignment,
  },
  {
    icon: 'fas fa-tag',
    label: 'Services Desired',
    condition: servicesDesired.value,
    value: servicesDesired.value,
  },
  {
    icon: 'fas fa-seedling',
    label: 'Investment Objective',
    condition: riskProfile?.value?.investment_objective,
    value: riskProfile?.value?.investment_objective,
  },
  {
    icon: 'fas fa-hourglass-end',
    label: 'Target Retirement Age',
    condition: retirementAge.value,
    value: retirementAge.value,
  },
  {
    icon: 'fas fa-bullseye',
    label: 'Financial Goals',
    condition: financialGoals.value,
    value: financialGoals.value,
    bold: true,
  },
]));
</script>

<style lang="css" scoped>
.key-subinfos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem 2rem;
}

.bold-subinfo {
  grid-column: 3;
  grid-row: 1 / span 2;
}

.subinfo {
  color: var(--stk-text-strong);
  font-weight: 500;
  line-height: 1.25;

  &.is-bold {
    font-size: 1.25em;
  }
}

.not-available {
  color: var(--stk-text-weak);
}

.loading-zone {
  color: var(--stk-border);
  display: flex;
  align-items: center;
}
</style>
